/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import Header from 'components/User/Header';
import { Spinner } from 'react-bootstrap';
import {
  Route, Routes, useNavigate,
} from 'react-router-dom';
import {
  DASHBOARD, HISTORIC, PROJECTS, PROFILE, ACTIVE_PROJECTS, FUNDS,
  FOUND_PROJECTS,
  OPPORTUNITIES,
  OPPORTUNITIES_DETAIL,
  OPPORTUNITIES_DETAIL_ID,
  CALENDAR,
  DOCUMENTATION,
} from 'constants/routes';
import Dashboard from 'screens/User/Dashboard';
import Project from 'screens/User/Project';
import Funds from 'screens/User/Funds';
import Historic from 'screens/User/Historic';
import OpportunitiesDashboard from 'screens/User/Opportunities/Dashboard';
import OpportunityDetail from 'screens/User/Opportunities/Detail';
import Profile from 'screens/User/Profile';
import handlePromise from 'utils/Promise';
import InvestmentAccountService from 'services/api/InvestmentAccount';
import ProjectsService from 'services/api/Projects';
import _ from 'lodash';
import ProfileService from 'services/api/Profile';
import AuthService from 'services/api/Auth';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserAccount, updateUserAccount } from 'store/User';

import ActiveProjects from 'screens/User/ActiveProjects';
import Docs from 'screens/User/Docs';
import Sidebar from 'components/User/Sidebar';
import Footer from 'components/User/Footer';
import { PromotionSummary } from 'types/Project';
import FoundProject from '../FoundProject';
import Calendar from '../Calendar';

function UserLayout() {
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState<any[]>( [] );
  const [promotionsSummary, setPromotionsSummary] = useState<PromotionSummary[]>( [] );
  const [profile, setProfile] = useState<any>();
  const [readyLayout, setReadyLayout] = useState<boolean>( false );
  const userAccountId = useSelector( selectUserAccount );
  const dispatch = useDispatch();

  const getApiVersion = useCallback( async () => {
    await handlePromise( AuthService.getApiVersion() );
  }, [] );

  const getProfileData = useCallback( async () => {
    const [, profileResponse, profileData] = await handlePromise( ProfileService.getProfile() );
    if ( profileData?.isNew ) {
      navigate( '/force-change-password' );
      return;
    }
    if ( profileResponse.ok ) setProfile( profileData );
  }, [] );

  const getAccount = useCallback( async () => {
    // GET ACCOUNTS
    const [, accountsResponse, accountsData] = await handlePromise(
      InvestmentAccountService.getInvestmentAccounts(),
    );
    if ( accountsResponse.ok ) {
      const accountsList = _.sortBy( accountsData, 'nameCuentadeInversion' );
      setAccounts( accountsList );

      if ( ( !userAccountId || userAccountId === 'admin' ) && accountsList.length ) {
        dispatch( updateUserAccount( accountsList[0].cuentaDeInversionId ) );
      }
      // GET ALL
      const [, summaryResponse, summaryData] = await handlePromise(
        ProjectsService.getAccountProjectsSummary( userAccountId ),
      );
      if ( summaryResponse.ok ) {
        const orderedData = _.chain( summaryData )
          .filter( ( item:PromotionSummary ) => item.tipoDeProyecto !== 'Proyecto de un fondo' )
          .orderBy( 'codigoPromocion', 'asc' )
          .value();
        setPromotionsSummary( orderedData as PromotionSummary[] );
      }

      if ( summaryData?.length ) {
        setReadyLayout( true );
      } else {
        setTimeout( () => {
          setReadyLayout( true );
        }, 800 );
      }
    }
  }, [userAccountId] );

  useEffect( () => {
    getApiVersion();
  }, [getApiVersion] );

  useEffect( () => {
    getProfileData();
    getAccount();
  }, [userAccountId] );

  return (
    <>
      <div className="container-xxl p-0 position-relative">
        <Sidebar promotionsSummary={promotionsSummary} />
        <div className="body-container">
          <Header accounts={accounts} profile={profile} promotionsSummary={promotionsSummary} />
          {readyLayout ? (
            <Routes>
              <Route path={HISTORIC} element={<Historic />} />
              <Route path={OPPORTUNITIES} element={<OpportunitiesDashboard />} />
              <Route path={OPPORTUNITIES_DETAIL} element={<OpportunityDetail />} />
              <Route path={OPPORTUNITIES_DETAIL_ID} element={<OpportunityDetail />} />
              <Route path={`${PROJECTS}/:id/:slug`} element={<Project />} />
              <Route path={`${FOUND_PROJECTS}/:promocionId/:id/:slug`} element={<FoundProject />} />
              <Route path={`${FUNDS}/:id/:slug`} element={<Funds />} />
              <Route path={PROFILE} element={<Profile />} />
              <Route path={ACTIVE_PROJECTS} element={<ActiveProjects />} />
              <Route path={DASHBOARD} element={<Dashboard />} />
              <Route path={CALENDAR} element={<Calendar />} />
              <Route path={DOCUMENTATION} element={<Docs />} />
              {/* <Redirect from="*" to="/" /> */}
            </Routes>
          )
            : (
              <div className="app-loading">
                <Spinner
                  animation="border"
                  variant="primary"
                  style={{
                    width: '3rem',
                    height: '3rem',
                  }}
                />
              </div>
            )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default UserLayout;
